import { render } from "./EmailHeaderLayOut.vue?vue&type=template&id=8cfc280a"
const script = {}

import "./EmailHeaderLayOut.vue?vue&type=style&index=0&id=8cfc280a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__